import { render, staticRenderFns } from "./PcVersion.vue?vue&type=template&id=6a29fa28"
import script from "./PcVersion.vue?vue&type=script&lang=js"
export * from "./PcVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports